import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setUrl } from "../../../../../helper/utils";

const DeliveryDays = () => {
  const [shippingTime, setShippingTime] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();
  const location = useLocation();

  const weekRef = useRef(null);
  const daysRef = useRef(null);

  const handleShippingTime = () => {
    if (daysRef.current.checked) {
      setShippingTime(15);
    } else if (weekRef.current.checked) {
      setShippingTime(7);
    } else {
      setShippingTime("");
    }
  };

  useEffect(() => {
    if (shippingTime !== null) {
      navigate(
        setUrl(location.pathname, searchParams, "shippingTime", shippingTime)
      );
    }
  }, [shippingTime]);

  useEffect(() => {
    if (searchParams.get("shippingTime")) {
      setShippingTime(searchParams.get("shippingTime"));
    } else {
      setShippingTime("");
    }
  }, [location]);

  return (
    <div className="product_filteration_section">
      <div className="price_filteration">
        <h1 className="filter_heading">DELIVERY DAYS</h1>

        <div className="filter_items_list days_filter_list">
          <div className="filter_item">
            <input
              type="checkbox"
              id="week"
              value={7}
              name="week"
              onChange={() => handleShippingTime()}
              ref={weekRef}
              checked={parseInt(shippingTime) <= 15 && shippingTime !== '' && shippingTime !== null}
            />
            <label htmlFor="week">Get it in a Week</label>
          </div>

          <div className="filter_item">
            <input
              type="checkbox"
              id="15Days"
              value={15}
              name="days"
              onChange={() => handleShippingTime()}
              ref={daysRef}
              checked={shippingTime == 15}
            />
            <label htmlFor="15Days">Get it in 15 Days</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryDays;
